import { render, staticRenderFns } from "./TongBuGoodOrder.vue?vue&type=template&id=55f4f95c&scoped=true&"
import script from "./TongBuGoodOrder.vue?vue&type=script&lang=js&"
export * from "./TongBuGoodOrder.vue?vue&type=script&lang=js&"
import style0 from "./TongBuGoodOrder.vue?vue&type=style&index=0&id=55f4f95c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f4f95c",
  null
  
)

export default component.exports